export const ApprovalRules = {
  NON_SEQUENTIAL: 'NON_SEQUENTIAL',
  ANY_CAN_APPROVE: 'ANY_CAN_APPROVE',
  SEQUENTIAL: 'SEQUENTIAL'
};